<template>
    <div>
		<card>
			<div class="multiple">
				<div class="child-div">时间区间</div>
				<RadioGroup v-model="timePeriod" @on-change="getList">
					<Radio label="0"><span>不限</span></Radio>
					<Radio label="1"><span>今日</span></Radio>
					<Radio label="2"><span>昨日</span></Radio>
					<Radio label="3"><span>本周</span></Radio>
					<Radio label="4"><span>上周</span></Radio>
					<Radio label="5"><span>本月</span></Radio>
					<Radio label="6"><span>上月</span></Radio>
					<Radio label="7"><span>自定义</span></Radio>
					<DatePicker :value="timePeriodDate" @on-change="timePeriodDateChange" type="daterange"
								placeholder="选择日期" style="width: 200px"></DatePicker>
				</RadioGroup>
			</div>
			<div class="multiple">
				<div class="child-div">跟进团队</div>
					<Select v-model="followDepartment" clearable @on-change="getList" style="width:150px;"
						placeholder="跟进团队">
						<Option v-for="item in departmentList" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
					<Button style="margin-left: 20px;" type="primary" v-on:click="initSearch()">重置</Button>
					<Button v-if="userInfo.role_type == 4" style="margin-left: 20px;" type="primary" v-on:click="lookClientCallList">客户拨打详情</Button>
			</div>
			<!--div class="multiple">
				<div class="child-div">统计方式</div>
				<RadioGroup v-model="statisticsWay" @on-change="getList">
					<Radio :label="1"><span>媒体代码</span></Radio>
					<Radio :label="2"><span>媒体渠道</span></Radio>
				</RadioGroup>
				<Button class='ivu-btn-circle' style="margin-left: 30px" type="primary" @click="getList">搜索</Button>
			</div-->
			<!--div class="multiple">
				<div class="child-div">统计方式</div>
				<RadioGroup v-model="statisticsWay">
					<Radio :label="1"><span>媒体代码</span></Radio>
					<Radio :label="2"><span>媒体渠道</span></Radio>
				</RadioGroup>
			</div>
			<div class="multiple">
				<div class="child-div">下级渠道</div>
				<Select v-model="shopId" style="width:200px">
					<Option v-for="item in shopList" :value="item.value" :key="item.value">
						{{ item.label }}
					</Option>
				</Select>
				<Button class='ivu-btn-circle' style="margin-left: 30px" type="primary" @click="getList">搜索</Button>
				<Button class='ivu-btn-circle' style="margin-left: 15px" @click="initSearch">重置</Button>
			</div-->			
		</card>
        <div style="width: 100% ; margin-top: 20px;">
            <Table stripe border :columns="columns" :data="datas"  ref="table">
				<template slot-scope="{ index,row }" slot="call_times">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clickCallTimes(row.id)">{{row.call_times}}</span>
				</template>
				<template slot-scope="{ index,row }" slot="follow_num">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clientClick(row.id,3,4,0)">{{row.follow_num}}</span>
				</template>
				<template slot-scope="{ index,row }" slot="visit_num">
					<span style="color:#63B3E6;cursor: pointer;"
						@click.stop="visitDataClick(row.id,1)">{{row.visit_num}}</span>
				</template>
				<template slot-scope="{ index,row }" slot="get_pool_nums">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clientClick(row.id,3,6,0)">{{row.get_pool_nums}}</span>
				</template>
				<template slot-scope="{ index,row }" slot="client_nums">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clientClick(row.id,3,4,0)">{{row.client_nums}}</span>
				</template>
				<template slot-scope="{ index,row }" slot="start_0">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clientClick(row.id,3,4,1)">{{row.start_0}}</span>
				</template>	
				<template slot-scope="{ index,row }" slot="start_1">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clientClick(row.id,3,4,2)">{{row.start_1}}</span>
				</template>	
				<template slot-scope="{ index,row }" slot="start_2">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clientClick(row.id,3,4,3)">{{row.start_2}}</span>
				</template>	
				<template slot-scope="{ index,row }" slot="start_3">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clientClick(row.id,3,4,4)">{{row.start_3}}</span>
				</template>	
				<template slot-scope="{ index,row }" slot="start_4">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clientClick(row.id,3,4,5)">{{row.start_4}}</span>
				</template>
				<template slot-scope="{ index,row }" slot="start_5">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="clientClick(row.id,3,4,6)">{{row.start_5}}</span>
				</template>					
            </Table>
        </div>
		<Modal v-model="clickJumpClientShow" width="1300" height="500">
			<ClickJumpClient ref="ClickJumpClient" :timePeriod="timePeriod" :timePeriodDate="timePeriodDate" :get_uid="get_uid" :start="start" :client_type="client_type" :timeType="timeType"></ClickJumpClient>
		</Modal>
		<Modal v-model="showCallLogModal" width="1300" height="520">
			<callLogList ref="callLogList" :timePeriod="timePeriod" :timePeriodDate="timePeriodDate" :get_uid="get_uid" ></callLogList>
		</Modal>
		<Modal v-model="visitDataModal" width="1200" title="来访客户">
			<TodayCustomer :follow_uid_props="get_uid" :timePeriod_props="timePeriod"
				:timePeriodDate_props="timePeriodDate"></TodayCustomer>
		</Modal>
    </div>
</template>
<script>
    import {getAllMediumCode, getAllMedium, getMediaStatics, getAllShop} from "../../api/runSet";
	import {getClientNums,getClientStatics,getDataReport,getClientFollowAnalyse} from "../../api/statics.js";
	import ClickJumpClient from '../client/ClickJumpClient.vue';
	import TodayCustomer from '../task/TodayCustomer.vue'
	import callLogList from './components/callLogList.vue';
	import {
		getDepartmentList,
	} from '@/api/user'
	import {mapGetters} from "vuex";

	export default {
        name: "client_follow_analyse",
        components: {
			ClickJumpClient,
			callLogList,
			TodayCustomer
		},

        data() {
            return {
                modal: false,
				clickJumpClientShow:false,
				showCallLogModal:false,
				visitDataModal: false,
                timePeriod: '1',
				timeType:'1',
				get_uid:'',
				start:'',
				client_type:'',
                statisticsWay: 1,
                timePeriodDate: [],
                shopId: '',
                shopList: [
                ],
                datas: [],
				departmentList: [],
				followDepartment:'',
                columns: [
					{
					    "title": "排序",
					    "type": "index",
						"align":"center",
						"fixed": 'left',
						width:"50px"
					},
                    {
                        "title": "名称",
                        "key": "name",
						"align":"center",
						"fixed": 'left'
                    },
					{
					    "title": "部门",
					    "key": "department_name",
						"align":"center",
						"fixed": 'left'
					},
					{
					    "title": "通时",
					    "key": "duration",
						"align":"center",
						sortable: true
					},
					{
					    "title": "通次",
					    "slot": "call_times",
						"align":"center",
						sortable: true
					},
					{
					    "title": "公共池领取数",
					    "slot": "get_pool_nums",
						"align":"center",
						sortable: true
					},
					{
					    "title": "上门",
					    "slot": "visit_num",
						"align":"center",
						sortable: true
					},
					{
					    "title": "业绩",
					    "key": "repay_money",
						"align":"center",
						sortable: true
					},
					{
					    "title": "眼睛查看数",
					    "key": "lookNum",
						"align":"center",
						sortable: true
					},
					{
					    "title": "app拨打数",
					    "key": "callNum",
						"align":"center",
						sortable: true
					},
                    {
                        "title": "跟进数",
                        "slot": "follow_num",
						"align":"center",
						sortable: true
                    },
					{
					    "title": "跟进客户数",
					    "slot": "client_nums",
						"align":"center",
						sortable: true
					},
					{
					    "title": "跟进0星",
					    "slot": "start_0",
						"align":"center",
						sortable: true
					},
					{
					    "title": "跟进1星",
					    "slot": "start_1",
						"align":"center",
						sortable: true
					},
					{
					    "title": "跟进2星",
					    "slot": "start_2",
						"align":"center",
						sortable: true
					},
					{
					    "title": "跟进2星+",
					    "slot": "start_3",
						"align":"center",
						sortable: true
					},
					{
					    "title": "跟进3星",
					    "slot": "start_4",
						"align":"center",
						sortable: true
					},
					{
					    "title": "跟进4星",
					    "slot": "start_5",
						"align":"center",
						sortable: true
					},
                ],
            }
        },
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function () {
			this.loadData();
			this.getList();
		},
        methods: {
			timePeriodDateChange(e) {
				this.timePeriodDate = e;
				this.getList();
			},
			clientClick(get_uid,timeType,client_type,start) {
				let that = this;
				//time:时间  today：今天 yesterday:昨天 week:本周 thismonth:本月
				//timeType:时间类型 1：客户申请时间 2：分发时间 3、备注更新时间
				console.log(get_uid)
				that.get_uid = get_uid?get_uid:0;
				that.timeType = 0;
				that.client_type = client_type;
				that.start = start
				that.clickJumpClientShow = true;
				/*
				let routeData = this.$router.resolve({
				    name: 'ClickJumpClient',
				    query: {
						get_uid:get_uid,
						status:status,
						start:start,
						timePeriod:this.timePeriod,
						timePeriodDate:this.timePeriodDate,
						timeType:timeType
				    }
				})
				*/
			
			},
			visitDataClick(type_id, type) {
				let that = this;
				if (type == 1) {
					that.get_uid = type_id;
				} else {
					that.department_id = type_id;
				}
				that.visitDataModal = true;
			},
			clickCallTimes(get_uid){
				let that = this;
				that.get_uid = get_uid?get_uid:0;
				that.showCallLogModal = true;				
			},
			lookClientCallList(){
				let that = this;
				this.timePeriod = '1';
				that.get_uid = 0;
				that.showCallLogModal = true;	
			},
			initSearch() {
				this.mediumCodeId = '';
				this.statisticsWay = 1;
				this.mediumId = '';
				this.timePeriod = '1';
				this.timePeriodDate = [];
				this.followDepartment ='',
				this.getList();
			},
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getAllShop(that, data);
				that.shopList = res.data.list;
				res = await getDepartmentList(that, data);
				if (res.code == 1) {
					that.departmentList = res.data.list;
				}
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				let res = await getClientFollowAnalyse(that, data);
				if(res.data.list !== null){
					that.datas = res.data.list;
				}
				
			},
			search() {
				this.getList();
			}
        },


    }
</script>
<style scoped lang="less">
    .red {
        color: red;
    }

    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;
        align-items: center;

        .child-div {
            width: 70px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
        }
    }

    .hong {
        color: #F56171;
        font-weight: bold;
    }

    .lan {
        color: #124386;
        font-weight: bold;
    }

    .sousuo {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .yl-flex {
        display: flex;
    }

    .flex_between {
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }

    .green-bg {
        background: #18bc9c;
    }

    .blue-bg {
        background: #54A1F3;
    }

    .person {
        font-size: 14px;
        color: white;
        border-radius: 50%;
        width: 22px;
        height: 20px;
    }

    .in-block {
        display: inline-block;
    }
	/deep/ .ivu-table table {
		width: 100% !important;
	}
	
	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}
	
	/deep/ .ivu-table .table-blue-row td {
		color: #FF6699;
	}
	
	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
	
	/deep/ .client_name {
		display: inline-block;
		margin: 0 4px;
		color: #85c7ff;
	}
</style>
